var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-avatar",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"avatar-circle"},[_c('span',{staticClass:"initials"},[_vm._v(_vm._s(_vm.initials))])]),_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }